import { createFileRoute, redirect } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'
import {
  getDefaultUserMeTenant,
  isSelectedDcManager
} from '@/features/auth/models'
import { USER_TYPE } from '@/libs/api/types'
import {
  selectedDcIdAtom,
  tenantStore
} from '@/routes/_protected/$tenantKey/-states'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/additional-payment-categories/create'
)({
  loader: async ({ context: { auth } }) => {
    return {
      authUser: auth.user
    }
  },
  meta: () => [{ title: MENU.NEW_REGISTRATION }],
  beforeLoad: ({ context: { auth } }) => {
    // DCユーザー以外、および選択中拠点の拠点マネージャ以外は追加運賃項目一覧にリダイレクト（#3957）
    // selectedDcId 未確定時はリダイレクトしない（登録可否は BE の 403 で担保）
    const selectedDcId = tenantStore.get(selectedDcIdAtom)
    if (
      auth?.user?.type !== USER_TYPE.OWNER ||
      (selectedDcId && !isSelectedDcManager(auth.user, selectedDcId))
    ) {
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}/settings/additional-payment-categories`
      })
    }
  }
})
